var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextCitron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.246139 15.786C0.574325 16.0713 1.10642 16.0713 1.4346 15.786L9.75386 8.55334C9.92854 8.40147 10.0102 8.19939 9.99898 8.00054C10.0105 7.8013 9.92883 7.59878 9.75386 7.44666L1.4346 0.213991C1.10642 -0.0713303 0.574325 -0.0713303 0.246139 0.213991C-0.0820464 0.499312 -0.0820464 0.961911 0.246139 1.24723L8.013 8L0.246139 14.7528C-0.0820464 15.0381 -0.0820464 15.5007 0.246139 15.786Z",
    fill: "#E6F972"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextCitron);
export default __webpack_public_path__ + "static/media/next-citron.69a4bcf1c37e8910486f624420da635f.svg";
export { ForwardRef as ReactComponent };